import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getComponentsStyles = (theme: Theme) =>
  StyleSheet.create({
    emptyState: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: theme.spacing.lg,
    },
    emptyText: {
        textAlign: 'center',
    }
});